<template>
	<ui-modal
		icon="fal fa-clock"
		:title="titleModal"
		:load-success="loader.modalSuccess"
		:load="loader.modalLoading"
		:name="modalName"
	>
		<template>
			<div class="area-card">
				<div v-show="loader.body" class="loading-card">
					<ui-load-indicator bgColor="#e7e9f4" color="#69D296" :h="50" :stroke="8" />
				</div>

				<div class="body-modal">
					<ui-input
						v-model="form.name"
						label="Nome da regra:"
						placeholder="Utilize um nome descritivo para a regra."
						type="text"
						size="md"
					/>

					<div class="grid-50">
						<div>
							<ui-select-2
								v-model="form.funnel_stage_id"
								:data="options.stages"
								item-label="name"
								return-value="id"
								label="Etapa da regra:"
								@input="handleStatusOptions"
							/>
						</div>

						<div>
							<ui-select-2
								v-model="form.funnel_stage_status_id"
								:data="options.status"
								:disabled="disableStatus"
								item-label="name"
								return-value="id"
								label="Status da regra:"
								align="right"
							/>
						</div>

						<div>
							<ui-input
								v-model="form.time_start"
								:mask="timeMask"
								label="Período inicial da regra (em horas):"
								placeholder="Horas"
							/>
						</div>

						<div>
							<ui-input
								v-model="form.time_end"
								:mask="timeMask"
								label="Período final da regra (em horas):"
								placeholder="Horas"
							/>
						</div>

						<div>
							<ui-select-color
								v-model="form.color"
								:colors="colors"
								:disabled-color="selectedColorsStageStatus"
								label="Cor da regra:"
							/>
						</div>
					</div>
				</div>
			</div>
		</template>

		<template #footer>
			<ui-button design="md success" :disabled="!canSubmit" @click="submit"
				>Salvar Regra</ui-button
			>
		</template>
	</ui-modal>
</template>
<script>
	import { uiModal } from '@/components/ui/modal'
	import { uiButton } from '@/components/ui/buttons'
	import { uiInput, uiSelect2, uiSelectColor } from '@/components/ui/form'
	import { uiLoadIndicator } from '@/components/ui'

	import { utilMixin, formMixin, alertMixin } from '@/mixins'

	import { idle } from '@/services/axios'

	const defaultForm = () => ({
		color: '',
		name: '',
		time_start: '',
		time_end: '',
		funnel_stage_id: null,
		funnel_stage_status_id: null,
	})

	const defaultEdit = () => ({
		mode: false,
		itemId: null,
	})

	const defaultLoader = () => ({
		body: false,
		modalLoading: false,
		modalSuccess: false,
	})

	export default {
		name: 'idleness-rules-modal',
		components: {
			uiModal,
			uiButton,
			uiInput,
			uiSelect2,
			uiSelectColor,
			uiLoadIndicator,
		},

		mixins: [utilMixin, formMixin, alertMixin],

		props: {
			name: {
				type: String,
				required: true,
			},

			modalName: {
				type: String,
				required: true,
			},

			colors: {
				type: Array,
				required: true,
			},

			stages: {
				type: Array,
				required: true,
			},

			selectedColors: {
				type: Array,
				required: true,
			},

			selectedTime: {
				type: Array,
				required: true,
			},
		},

		data() {
			return {
				form: { ...defaultForm() },
				loader: { ...defaultLoader() },
				edit: { ...defaultEdit() },
				options: {
					stages: [],
					status: [],
				},

				timeMask: {
					mask: '####',
					tokens: {
						'#': {
							pattern: /\d/,
							transform: (v) => v,
						},
					},
				},
				oldForm: {},
			}
		},

		created() {
			this.$root.$on(`modal-open-${this.modalName}`, (payload) => {
				this.reset()

				this.options.stages = this.stages

				if (!!payload && payload.id) {
					this.edit.mode = true
					this.edit.itemId = payload.id
					this.form.name = payload.name
					this.form.color = payload.color
					this.form.time_start = payload.time_start / 60
					this.form.time_end = payload.time_end / 60

					// Stage & Status
					this.form.funnel_stage_id = payload.funnel_stage_id
					this.handleStatusOptions(this.form.funnel_stage_id)
					this.form.funnel_stage_status_id = payload.funnel_stage_status_id
				}

				this.loader.body = false
				this.$mx_copyOldForm()
			})
		},

		destroyed() {
			this.$root.$off(`modal-open-${this.modalName}`)
		},

		computed: {
			selectedColorsStageStatus() {
				let colors = []

				const catchColor = (colorList) => {
					return colorList.map((color) => color.color)
				}

				if (this.form.funnel_stage_status_id)
					colors = catchColor(
						this.selectedColors.filter(
							(color) =>
								color.funnel_stage_status_id == this.form.funnel_stage_status_id,
						),
					)
				else
					colors = catchColor(
						this.selectedColors.filter(
							(color) =>
								color.funnel_stage_id == this.form.funnel_stage_id &&
								!color.funnel_stage_status_id,
						),
					)

				return colors
			},

			canSubmit() {
				return (
					!this.loader.body &&
					this.$mx_isFormChanged &&
					!!this.form.name &&
					!!this.form.color &&
					!!this.form.time_start &&
					!!this.form.time_end &&
					(parseInt(this.form.time_start) < parseInt(this.form.time_end)) &&
					this.form.funnel_stage_id
				)
			},

			titleModal() {
				return this.edit.mode ? 'Editar Regra' : 'Criar Regra'
			},

			validateIdle() {
				const { name, color, time_start, time_end, funnel_stage_id, funnel_stage_status_id } = this.form

				let data = {
					name,
					color,
					time_start: parseInt(time_start) * 60,
					time_end: parseInt(time_end) * 60,
					funnel_stage_id,
					funnel_stage_status_id,
				}

				if (this.edit.mode) data.id = this.edit.itemId
				if (!this.$mx_hasValue(data.funnel_stage_id)) data.funnel_stage_id = null
				if (!this.$mx_hasValue(data.funnel_stage_status_id)) data.funnel_stage_status_id = null

				return data
			},

			disableStatus() {
				return this.options.status.length == 0
			},
		},

		methods: {
			closeModal() {
				this.$root.$emit(`modal-close-${this.modalName}`)
				this.loader.body = true
			},

			handleStatusOptions(id) {
				this.options.status = []
				this.form.funnel_stage_status_id = null

				const options = this.options.stages.find((stage) => stage.id == id)
				if (!options) return

				this.options.status = options.status
			},

			reset() {
				this.form = { ...defaultForm() }
				this.loader = { ...defaultLoader() }
				this.edit = { ...defaultEdit() }
			},

			async submit() {
				try {
					this.loader.modalLoading = true

					if (this.edit.mode) await idle.updateV2('', this.edit.itemId, this.validateIdle)
					else await idle.createV2('', this.validateIdle)

					setTimeout(() => {
						this.$root.$emit(`${this.name}:update`, this.validateIdle)
						this.loader.modalSuccess = true
						setTimeout(() => {
							this.closeModal()
						}, 500)
					}, 500)

					this.$mx_copyOldForm()
					//...
				} catch (error) {
					this.$mx_alertThisOnError(error)
					this.loader.modalLoading = false
				}
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
